import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Dialog,
    Alert,
    Snackbar,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import {
    useGetAllCarsPlateNumberQuery,
    useGetAllCarsQuery
} from "../../../redux/slices/seller/sale/allCarPlateNumber.js";
import {
    useGetProductsForSalesByPlateNumberQuery
} from "../../../redux/slices/seller/sale/allProductSlince.js";
import {
    useAddDiscountMutation,
    useDeactiveDiscountMutation,
    useGetAllDiscountsByPlateQuery
} from "../../../redux/slices/admin/machine/priceDiscountSlince.js";
import {
    Pagination
} from "@mui/material";
import { useOutletContext } from "react-router-dom";
import "../../../styles/admin.css/machine-modifications-css/price-discount.css";

export default function PriceDiscount() {

    const { sidebarOpen, activeLog, setActiveLog } = useOutletContext();
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;
    const [productPage, setProductPage] = useState(1);
    const productsPerPage = 50;

    const [deletingId, setDeletingId] = useState(null);
    const [addDiscount, { isLoading: addDiscountLoading }] = useAddDiscountMutation();
    const [deactiveDiscount, { isLoading: deactiveLoading }] = useDeactiveDiscountMutation();

    const normalizePlate = (value = "") =>
        value.toLowerCase().replace(/[^a-z0-9]/g, "");
    const [plateSearch, setPlateSearch] = useState("");

    const { data: discountsData } = useGetAllDiscountsByPlateQuery(activeLog?.plateNumber, {
        skip: !activeLog
    });
    const discountsFromApi = discountsData?.data || [];


    const { data: platesData, isLoading: platesLoading } = useGetAllCarsPlateNumberQuery(undefined, {
        refetchOnMountOrArgChange: true,
        refetchOnReconnect: true,
        refetchOnFocus: true
    });
    const plateNumbers = platesData?.data || [];


    const { data: allCarsData, isLoading: logsLoading } = useGetAllCarsQuery(undefined, {
        refetchOnMountOrArgChange: true,
        refetchOnReconnect: true,
        refetchOnFocus: true
    });
    const logs = allCarsData?.data || [];


    const { data: plateProductsData, isLoading: productsLoading } = useGetProductsForSalesByPlateNumberQuery(
        activeLog?.plateNumber,
        {
            skip: !activeLog,
            refetchOnMountOrArgChange: true,
            refetchOnReconnect: true
        }
    );
    const products = plateProductsData?.data || [];


    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1300);
    const [extraHeight, setExtraHeight] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedPlate, setSelectedPlate] = useState("all");

    const [selectedCategory, setSelectedCategory] = useState("all");
    const [selectedSubCategory, setSelectedSubCategory] = useState("all");

    const [popupOpen, setPopupOpen] = useState(false);
    const [discountValue, setDiscountValue] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [toast, setToast] = useState({ open: false, severity: "success", message: "" });
    const handleCloseToast = () => {
        setToast({ ...toast, open: false });
    };

    const [discountedProducts, setDiscountedProducts] = useState([]);



    const categoryOptions = [
        "Yaxıt və maye məhsulları",
        "Avtomobil aksesuarları",
        "Avtomobil hissələri / ehtiyat hissələri"
    ];

    const subCategoryOptions = {
        "Yaxıt və maye məhsulları": ["Motor yağı", "Transmissiya yağı", "Hidravlik yağ", "Antifriz", "Benzin oktan qaldıran", "Dizel setan qaldıran"],
        "Avtomobil aksesuarları": ["Svarovski"],
        "Avtomobil hissələri / ehtiyat hissələri": ["Hava filtiri", "Yağ filtiri", "Benzin filtiri", "Salon filtiri", "Transmissiya filtiri", "Əyləc mayesi"]
    };

    const filteredLogs = logs.filter(emp => {
        const plateMatch =
            selectedPlate === "all" || emp.plateNumber === selectedPlate;

        const searchMatch =
            !plateSearch ||
            normalizePlate(emp.plateNumber).includes(
                normalizePlate(plateSearch)
            );

        return plateMatch && searchMatch;
    });

    const visibleLogs = activeLog ? [activeLog] : filteredLogs;


    const filteredProducts = products.filter(p => {
        const categoryMatch = selectedCategory === "all" ||
            (subCategoryOptions[selectedCategory] && subCategoryOptions[selectedCategory].includes(p.subCategory)) ||
            p.category === selectedCategory;

        const subCategoryMatch = selectedSubCategory === "all" || p.subCategory === selectedSubCategory;

        const searchMatch = !searchTerm ||
            (p.name && p.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (p.code && p.code.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (p.fuelType && p.fuelType.toLowerCase().includes(searchTerm.toLowerCase()));

        return categoryMatch && subCategoryMatch && searchMatch;
    });

    useEffect(() => {
        if (activeLog) {

            window.scrollTo({ top: 0, behavior: "smooth" });


            const wrapper = document.querySelector('.price-discount-wrapper');
            if (wrapper) {
                wrapper.scrollTo({ top: 0, behavior: "smooth" });
            }
        }
    }, [activeLog]);


    const openPopup = (product) => {
        setSelectedProduct(product);
        setDiscountValue("");
        setPopupOpen(true);
    };


    const confirmDiscount = async () => {
        if (!selectedProduct || !activeLog) return;

        const discount = Number(discountValue);


        if (!discount || discount <= 0 || discount > selectedProduct.price) return;

        try {

            const res = await addDiscount({
                plateNumber: activeLog.plateNumber,
                productId: selectedProduct.id,
                amount: discount
            }).unwrap();


            setDiscountedProducts(prev => [
                ...prev,
                {
                    id: res.id,
                    serialNo: res.serialNo,
                    productId: res.productId,
                    productSerialNo: res.productSerialNo,
                    productName: res.productName,
                    customerName: res.customerName,
                    litr: res.litr,
                    subcategoryName: res.subcategoryName,
                    color: res.color,
                    plateNumber: res.plateNumber,
                    carId: res.carId,
                    amount: res.amount,
                    isActive: res.isActive
                }
            ]);


            setPopupOpen(false);
            setDiscountValue("");
            setToast({ open: true, severity: "success", message: "Uğurla Endirim edildi!" });

        } catch (error) {
            setToast({ open: true, severity: "info", message: "Yeniləmə zamanı xəta baş verdi!" });
            console.error("Discount add error:", error);
        }
    };



    const removeDiscounted = async (discountId) => {
        try {
            setDeletingId(discountId);

            await deactiveDiscount(discountId).unwrap();

            setDiscountedProducts(prev =>
                prev.filter(d => d.id !== discountId)
            );
            setToast({ open: true, severity: "success", message: "Endirim uğurla ləğv edildi." });
        } catch (error) {
            // If discount is already deleted (404), remove it from local state silently
            if (error.status === 404) {
                setDiscountedProducts(prev =>
                    prev.filter(d => d.id !== discountId)
                );
                setToast({ open: true, severity: "info", message: "Endirim artıq mövcud deyil." });
            } else {
                setToast({ open: true, severity: "info", message: "Yeniləmə zamanı xəta baş verdi!" });
                console.error("Silme hatası:", error);
            }
        } finally {
            setDeletingId(null);
        }
    };



    const isProductDiscounted = (productId) => {
        return discountedProducts.some(d => d.productId === productId && d.id);
    };


    useEffect(() => {
        const updateHeight = () => {
            const container = document.querySelector('.price-discount-wrapper');
            const header = document.querySelector('.price-discount-header');
            const divider = document.querySelector('.price-discount-divider');

            if (container && header && divider) {
                const h = container.clientHeight - header.offsetHeight - divider.offsetHeight;

                setExtraHeight(prev => (prev !== h ? h : prev));
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);




    useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth <= 1300);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        if (discountsFromApi && discountsFromApi.length > 0) {
            const mappedData = discountsFromApi.map(d => ({
                id: d.id,
                serialNo: d.serialNo,
                productId: d.productId,
                productSerialNo: d.productSerialNo,
                productName: d.productName,
                customerName: d.customerName,
                litr: d.litr,
                subcategoryName: d.subcategoryName,
                color: d.color,
                plateNumber: d.plateNumber,
                carId: d.carId,
                amount: d.amount,
                isActive: d.isActive
            }));


            setDiscountedProducts(mappedData);
        } else if (activeLog) {

            setDiscountedProducts([]);
        }
    }, [discountsFromApi, activeLog]);

    useEffect(() => {
        if (!activeLog) {
            setDiscountedProducts([]);
            setDeletingId(null);

            setSelectedCategory("all");
            setSelectedSubCategory("all");
            setSearchTerm("");

            setPopupOpen(false);
            setSelectedProduct(null);
            setDiscountValue("");
        }
    }, [activeLog]);

    const totalPages = Math.ceil(visibleLogs.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedVisibleLogs = visibleLogs.slice(startIndex, startIndex + itemsPerPage);
    const totalProductPages = Math.ceil(filteredProducts.length / productsPerPage);
    const productStartIndex = (productPage - 1) * productsPerPage;
    const paginatedProducts = filteredProducts.slice(productStartIndex, productStartIndex + productsPerPage);

    useEffect(() => {
        setPage(1);
    }, [selectedPlate]);

    useEffect(() => {
        setProductPage(1);
    }, [searchTerm, selectedCategory, selectedSubCategory, activeLog]);

    useEffect(() => {
        if (activeLog) {
            setPage(1);
        }
    }, [activeLog]);

    return (
        <Box className={`price-discount-wrapper ${sidebarOpen ? "price-discount-sidebar-open" : ""}`}>

            <Box className="price-discount-header">
                <Box className="price-discount-title">
                    <Typography style={{ color: "#545A61" }}>Qiymət endirimi</Typography>
                    <Divider className="price-discount-divider" />
                </Box>
                {!activeLog && (
                    <Box className="price-discount-filter-row">

                        <TextField
                            style={{ marginRight: 10 }}
                            size="small"
                            placeholder="Nömrə axtar..."
                            value={plateSearch}
                            onChange={(e) => setPlateSearch(e.target.value)}
                            className="price-discount-plate-search"
                        />

                        <FormControl size="small" className="price-discount-filter">
                            <InputLabel>Qeydiyat Nişanı</InputLabel>
                            <Select
                                value={selectedPlate}
                                label="Qeydiyat Nişanı"
                                onChange={(e) => setSelectedPlate(e.target.value)}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}

                            >
                                <MenuItem value="all">Hamısı</MenuItem>
                                {!platesLoading && plateNumbers.map((plate, idx) => (
                                    <MenuItem key={idx} value={plate.plateNumber}>{plate.plateNumber}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>


                    </Box>
                )}
            </Box>

            <TableContainer component={Paper} className={activeLog ? "price-discount-active-table" : "price-discount-main-table"} elevation={0}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>#No</strong></TableCell>
                            <TableCell><strong>Tam Ad</strong></TableCell>
                            <TableCell><strong>Əlaqə nömrəsi</strong></TableCell>
                            <TableCell><strong>Model</strong></TableCell>
                            <TableCell><strong>Nömrə nişanı</strong></TableCell>
                            <TableCell><strong>Seçimlər</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {logsLoading ? (
                            <TableRow key="loading-logs">
                                <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                            </TableRow >
                        ) : paginatedVisibleLogs.length === 0 ? (
                            <TableRow key="no-logs">
                                <TableCell colSpan={6} align="center">Məlumat tapılmadı</TableCell>
                            </TableRow>
                        ) : (
                            paginatedVisibleLogs.map((emp, index) => (
                                <TableRow key={emp.id}>
                                    <TableCell>{"#" + String(emp.serialNo || emp.id).padStart(4, "0")}</TableCell>
                                    <TableCell>{emp.firstName} {emp.lastName}</TableCell>
                                    <TableCell>+994 {emp.phone}</TableCell>
                                    <TableCell>{emp.model}</TableCell>
                                    <TableCell>{emp.plateNumber}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            className={activeLog ? "price-discount-button back" : "price-discount-button"}
                                            onClick={() => activeLog ? setActiveLog(null) : setActiveLog(emp)}
                                        >
                                            {activeLog ? "Geri" : "Endirim"}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {visibleLogs.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 1 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                        size="small"
                    />
                </Box>
            )}

            {activeLog && (

                <Box className="price-discount-details-wrapper" style={{ height: extraHeight }}>

                    {isMobileView ? (
                        <>
                            <Box className="price-discount-right-table">
                                <Box className="price-discount-right-filters">
                                    <Box style={{ display: 'flex', gap: '12px' }}>
                                        <FormControl size="small" className="price-discount-filter-item">
                                            <InputLabel>Kateqoriya</InputLabel>
                                            <Select
                                                value={selectedCategory}
                                                label="Kateqoriya"
                                                onChange={(e) => {
                                                    setSelectedCategory(e.target.value);
                                                    setSelectedSubCategory("all");
                                                }}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                }}
                                            >
                                                <MenuItem value="all">Hamısı</MenuItem>
                                                {categoryOptions.map((cat, idx) => (
                                                    <MenuItem key={idx} value={cat}>{cat}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl size="small" className="price-discount-filter-item" disabled={selectedCategory === "all"}>
                                            <InputLabel>Alt-kateqoriya</InputLabel>
                                            <Select
                                                value={selectedSubCategory}
                                                label="Alt-kateqoriya"
                                                onChange={(e) => setSelectedSubCategory(e.target.value)}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                }}
                                            >
                                                <MenuItem value="all">Hamısı</MenuItem>
                                                {selectedCategory !== "all" && subCategoryOptions[selectedCategory]?.map((sub, idx) => (
                                                    <MenuItem key={idx} value={sub}>{sub}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <TextField
                                        size="small"
                                        placeholder="Axtar..."
                                        className="price-discount-search-input"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </Box>

                                <TableContainer component={Paper} className="price-discount-right-inner-table" elevation={0}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#No</TableCell>
                                                <TableCell>Məhsul</TableCell>
                                                <TableCell>Qiymət</TableCell>
                                                <TableCell>Maya dəyəri</TableCell>
                                                <TableCell>Kod</TableCell>
                                                <TableCell>Yanacaq Növü</TableCell>
                                                <TableCell>Seçimlər</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {productsLoading ? (
                                                <TableRow key="loading-products">
                                                    <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                                                </TableRow>
                                            ) : paginatedProducts.length === 0 ? (
                                                <TableRow key="no-products">
                                                    <TableCell colSpan={6} align="center">Məlumat tapılmadı</TableCell>
                                                </TableRow>
                                            ) : (
                                                paginatedProducts.map((prod) => {

                                                    const disabled = isProductDiscounted(prod.id);
                                                    return (
                                                        <TableRow key={prod.id}>
                                                            <TableCell>{"#" + String(prod.serialNo || prod.id).padStart(4, "0")}</TableCell>
                                                            <TableCell>
                                                                {(() => {
                                                                    if (prod.subCategory === "Antifriz") {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L {prod.color}</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else if (prod.litr) {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else {

                                                                        return <span>{prod.name}</span>;
                                                                    }
                                                                })()}
                                                            </TableCell>
                                                            <TableCell>{prod.price}₼</TableCell>
                                                            <TableCell>{prod.costPrice ? `${prod.costPrice}₼` : "-"}</TableCell>
                                                            <TableCell>{prod.code || "-"}</TableCell>
                                                            <TableCell>{prod.fuelType || "-"}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    className="price-discount-button2"
                                                                    style={{
                                                                        background: disabled ? "#999" : "#d4b200"
                                                                    }}
                                                                    variant="contained"
                                                                    size="small"
                                                                    disabled={disabled}
                                                                    onClick={() => openPopup(prod)}
                                                                >
                                                                    Endirim
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })


                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {totalProductPages > 1 && (
                                    <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 1 }}>
                                        <Pagination
                                            count={totalProductPages}
                                            page={productPage}
                                            onChange={(e, value) => setProductPage(value)}
                                            color="primary"
                                            variant="outlined"
                                            shape="rounded"
                                            size="small"
                                        />
                                    </Box>
                                )}
                            </Box>

                            <Box className="price-discount-left-table">
                                <TableContainer component={Paper} className="price-discount-left-inner-table" elevation={0}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#No</TableCell>
                                                <TableCell>Məhsul</TableCell>
                                                <TableCell>Müştəri</TableCell>
                                                <TableCell>Nömrə nişanı</TableCell>
                                                <TableCell>Endirim</TableCell>
                                                <TableCell>Seçimlər</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {discountedProducts.length === 0 ? (
                                                <TableRow key="empty-discounts">
                                                    <TableCell colSpan={6} align="center">Endirim olunmuş məhsul yoxdur</TableCell>
                                                </TableRow>
                                            ) : (
                                                discountedProducts.map((prod) => (
                                                    <TableRow key={prod.id}>
                                                        <TableCell>{"#" + String(prod.productSerialNo || prod.productId).padStart(4, "0")}</TableCell>
                                                        <TableCell>
                                                            {(() => {
                                                                if (prod.subcategoryName === "Antifriz") {

                                                                    return (
                                                                        <span>
                                                                            <strong>{prod.litr}L {prod.color}</strong> {prod.productName}
                                                                        </span>
                                                                    );
                                                                } else if (prod.litr) {

                                                                    return (
                                                                        <span>
                                                                            <strong>{prod.litr}L</strong> {prod.productName}
                                                                        </span>
                                                                    );
                                                                } else {

                                                                    return <span>{prod.productName}</span>;
                                                                }
                                                            })()}
                                                        </TableCell>
                                                        <TableCell>{prod.customerName}</TableCell>
                                                        <TableCell>{prod.plateNumber}</TableCell>
                                                        <TableCell>{prod.amount}₼</TableCell>
                                                        <TableCell className="price-discount-actions-cell">
                                                            <Button
                                                                color="error"
                                                                variant="contained"
                                                                size="small"
                                                                disabled={deletingId === prod.id}
                                                                onClick={() => removeDiscounted(prod.id)}
                                                            >
                                                                {deletingId === prod.id ? "Silinir" : "Sil"}
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>



                        </>
                    ) : (
                        <>
                            <Box className="price-discount-left-table">
                                <TableContainer component={Paper} className="price-discount-left-inner-table" elevation={0}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#No</TableCell>
                                                <TableCell>Məhsul</TableCell>
                                                <TableCell>Müştəri</TableCell>
                                                <TableCell>Nömrə nişanı</TableCell>
                                                <TableCell>Endirim</TableCell>
                                                <TableCell>Seçimlər</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {discountedProducts.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={6} align="center">Endirim olunmuş məhsul yoxdur</TableCell>
                                                </TableRow>
                                            ) : (
                                                discountedProducts.map((prod) => (
                                                    <TableRow key={prod.id}>
                                                        <TableCell>{"#" + String(prod.productSerialNo || prod.productId).padStart(4, "0")}</TableCell>
                                                        <TableCell>
                                                            {(() => {
                                                                if (prod.subcategoryName === "Antifriz") {

                                                                    return (
                                                                        <span>
                                                                            <strong>{prod.litr}L {prod.color}</strong> {prod.productName}
                                                                        </span>
                                                                    );
                                                                } else if (prod.litr) {

                                                                    return (
                                                                        <span>
                                                                            <strong>{prod.litr}L</strong> {prod.productName}
                                                                        </span>
                                                                    );
                                                                } else {

                                                                    return <span>{prod.productName}</span>;
                                                                }
                                                            })()}</TableCell>

                                                        <TableCell>{prod.customerName}</TableCell>
                                                        <TableCell>{prod.plateNumber}</TableCell>
                                                        <TableCell>{prod.amount}₼</TableCell>
                                                        <TableCell className="price-discount-actions-cell">
                                                            <Button
                                                                color="error"
                                                                variant="contained"
                                                                size="small"
                                                                disabled={deletingId === prod.id}
                                                                onClick={() => removeDiscounted(prod.id)}
                                                            >
                                                                {deletingId === prod.id ? "Silinir" : "Sil"}
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>

                            {/* RIGHT TABLE (Ürünler) */}
                            <Box className="price-discount-right-table">
                                <Box className="price-discount-right-filters">
                                    <Box style={{ display: 'flex', gap: '12px' }}>
                                        <FormControl size="small" className="price-discount-filter-item">
                                            <InputLabel>Kateqoriya</InputLabel>
                                            <Select
                                                value={selectedCategory}
                                                label="Kateqoriya"
                                                onChange={(e) => {
                                                    setSelectedCategory(e.target.value);
                                                    setSelectedSubCategory("all");
                                                }}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                }}
                                            >
                                                <MenuItem value="all">Hamısı</MenuItem>
                                                {categoryOptions.map((cat, idx) => (
                                                    <MenuItem key={idx} value={cat}>{cat}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl size="small" className="price-discount-filter-item" disabled={selectedCategory === "all"}>
                                            <InputLabel>Alt-kateqoriya</InputLabel>
                                            <Select
                                                value={selectedSubCategory}
                                                label="Alt-kateqoriya"
                                                onChange={(e) => setSelectedSubCategory(e.target.value)}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                }}
                                            >
                                                <MenuItem value="all">Hamısı</MenuItem>
                                                {selectedCategory !== "all" && subCategoryOptions[selectedCategory]?.map((sub, idx) => (
                                                    <MenuItem key={idx} value={sub}>{sub}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <TextField
                                        size="small"
                                        placeholder="Axtar..."
                                        className="price-discount-search-input"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </Box>

                                <TableContainer component={Paper} className="price-discount-right-inner-table" elevation={0}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#No</TableCell>
                                                <TableCell>Məhsul</TableCell>
                                                <TableCell>Qiymət</TableCell>
                                                <TableCell>Maya dəyəri</TableCell>
                                                <TableCell>Kod</TableCell>
                                                <TableCell>Yanacaq Növü</TableCell>
                                                <TableCell>Seçimlər</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {productsLoading ? (
                                                <TableRow>
                                                    <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                                                </TableRow>
                                            ) : paginatedProducts.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={6} align="center">Məlumat tapılmadı</TableCell>
                                                </TableRow>
                                            ) : (
                                                paginatedProducts.map((prod) => {

                                                    const disabled = isProductDiscounted(prod.id);
                                                    return (
                                                        <TableRow key={prod.id}>
                                                            <TableCell>{"#" + String(prod.serialNo || prod.id).padStart(4, "0")}</TableCell>
                                                            <TableCell>
                                                                {(() => {
                                                                    if (prod.subCategory === "Antifriz") {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L {prod.color}</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else if (prod.litr) {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else {

                                                                        return <span>{prod.name}</span>;
                                                                    }
                                                                })()}
                                                            </TableCell>
                                                            <TableCell>{prod.price}₼</TableCell>
                                                            <TableCell>{prod.costPrice ? `${prod.costPrice}₼` : "-"}</TableCell>
                                                            <TableCell>{prod.code || "-"}</TableCell>
                                                            <TableCell>{prod.fuelType || "-"}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    className="price-discount-button2"
                                                                    style={{
                                                                        background: disabled ? "#999" : "#d4b200"
                                                                    }}
                                                                    variant="contained"
                                                                    size="small"
                                                                    disabled={disabled}
                                                                    onClick={() => openPopup(prod)}
                                                                >
                                                                    Endirim
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })


                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {totalProductPages > 1 && (
                                    <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 1 }}>
                                        <Pagination
                                            count={totalProductPages}
                                            page={productPage}
                                            onChange={(e, value) => setProductPage(value)}
                                            color="primary"
                                            variant="outlined"
                                            shape="rounded"
                                            size="small"
                                        />
                                    </Box>
                                )}
                            </Box>
                        </>
                    )}

                </Box>
            )}

            {/* --- Discount Popup --- */}
            <Dialog open={popupOpen} onClose={() => setPopupOpen(false)}>
                <DialogTitle>
                    Endirim məbləği
                    <Divider style={{ marginTop: 8, marginBottom: 16 }} />
                </DialogTitle>
                <DialogContent style={{ minWidth: "400px", minHeight: "160px", display: "flex", flexDirection: "column", gap: "16px" }}>
                    <TextField
                        type="number"
                        fullWidth
                        placeholder="Məbləğ daxil edin"
                        value={discountValue}
                        onChange={(e) => setDiscountValue(e.target.value)}
                        inputProps={{ min: 0, max: selectedProduct?.price || 0 }}
                    />
                    {selectedProduct && (
                        <Typography variant="body2" color="textSecondary">
                            Maksimum: {selectedProduct.price}₼, Minimum: 1₼
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions style={{ justifyContent: "flex-end", gap: "12px", padding: "16px" }}>
                    <Button onClick={() => setPopupOpen(false)} color="primary" variant="outlined">Ləğv et</Button>
                    <Button
                        onClick={confirmDiscount}
                        variant="contained"
                        color="primary"
                        disabled={addDiscountLoading}
                    >
                        Təsdiq et
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={toast.open}
                autoHideDuration={4000}
                onClose={handleCloseToast}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
